import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { addBrowserClasses, checkValidBrowser, checkCookiesEnabled } from '@kpd/framework-ngx';
import * as log from 'loglevel';

checkValidBrowser(document.body);
checkCookiesEnabled(navigator, document.body);
addBrowserClasses(document.body);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => log.error(err));
